var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-table-action"},[_c('mk-button',{staticClass:"list-table-action__apply",attrs:{"type":"text"},on:{"click":_vm.toExamineDetail}},[_vm._v("\n    查看\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }